var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#vote-up--ZlNyW';
                    var viewUrl = 'sprites.svg#view-vote-up--ZlNyW';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 11',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };